import React from 'react';

export default function ManagePhotosModal({
  setShowManagePhotosModal,
  theme,
  userPhotos,
  setUserPhotos,
  setSelectedDay
}) {
  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-md z-50 flex items-center justify-center p-6 animate-fadeIn">
      <div className={`${theme.card} border ${theme.border} rounded-[2.5rem] p-8 max-w-sm w-full space-y-6 max-h-[85vh] flex flex-col shadow-2xl`}>
        <div className={`flex justify-between items-center border-b ${theme.border} pb-4`}>
          <h3 className={`text-xl font-black ${theme.text}`}>Galería</h3>
          <button onClick={() => setShowManagePhotosModal(false)} className={`${theme.muted} font-bold text-xl hover:text-red-500 transition-colors`}>✕</button>
        </div>
        <div className="flex-1 overflow-y-auto space-y-4 pr-2">
          {Object.keys(userPhotos).length === 0 ? (
            <p className={`text-center text-sm ${theme.muted} py-10`}>La galería está vacía.</p>
          ) : (
            Object.entries(userPhotos).map(([dayNum, photoUrl]) => (
              <div key={dayNum} className={`${theme.secondary} p-3 rounded-[1.5rem] border ${theme.border} flex items-center justify-between gap-4`}>
                <img src={photoUrl} alt="Galería" className="w-16 h-24 object-cover rounded-2xl border border-gray-500/20" />
                <div className="flex-1">
                  <span className={`text-sm font-black block ${theme.text}`}>Día {dayNum}</span>
                </div>
                <div className="flex flex-col gap-2">
                  <button onClick={() => { setSelectedDay(Number(dayNum)); setShowManagePhotosModal(false); }} className={`px-5 py-2 ${theme.primary} text-[10px] font-black uppercase tracking-widest rounded-full`}>Ir</button>
                  <button onClick={() => { if(window.confirm('¿Borrar?')){ const newP={...userPhotos}; delete newP[dayNum]; setUserPhotos(newP);} }} className={`px-5 py-2 bg-transparent ${theme.muted} text-[10px] font-black uppercase tracking-widest rounded-full hover:text-red-500 transition-colors`}>Borrar</button>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}